<template>
  <div class="process-status-form">
    <show-handle-result-dialog @updateVisible="updateVisible" :dialogVisible="showDialog" :table-data="gridData" status="上机检测">
    </show-handle-result-dialog>
    <template v-if="isVendor">
      <pt-form-item label="是否合格" labelWidth="140px" :required="true">
        <el-radio-group v-model="statusForm.result" name="result" v-validate="'required'" data-vv-as="是否合格">
          <el-radio label="REPORT_GENERATE">合格</el-radio>
          <el-radio label="NOT_QUALIFIED_WAIT_FUTURE_ACTION">不合格</el-radio>
        </el-radio-group>
      </pt-form-item>
      <pt-form-item label="原因" labelWidth="140px" v-if="statusForm.result == 'NOT_QUALIFIED_WAIT_FUTURE_ACTION'" :required="true">
        <el-input type="textarea" data-vv-as="原因" v-validate="'required'" :rows="2" placeholder="请输入内容" v-model="statusForm.reason" @mousedown.stop.native @click.stop.native></el-input>
        <!-- <not-qualified-reason-data-analysised data-vv-as="原因" v-validate="'required'" v-model="statusForm.reason" @mousedown.stop.native @click.stop.native></not-qualified-reason-data-analysised> -->
      </pt-form-item>
    </template>
    <template v-else>
      <pt-form-item label="上传检测数据" labelWidth="140px" :required="true">
        <el-upload ref="qualityFile" class="upload-demo" v-model="statusForm.qualityFile" name="qualityFile" v-validate="'required'" data-vv-as="上传检测数据"
        action="aaa"
        :auto-upload="false"
        :multiple="false"
        :on-change="changHandler"
        :file-list="qualityFile"
        :before-upload="qualityFileSub">
            <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </pt-form-item>
      <pt-form-item label="数据类型" labelWidth="140px" :required="true">
        <sequencing-technology-type-selector name="sequencingTechnologyType" data-vv-as="数据类型" v-validate="'required'" v-model="statusForm.sequencingTechnologyType"></sequencing-technology-type-selector>
      </pt-form-item>
    </template>
    <pt-form-item label="实验人员" labelWidth="140px" :required="true">
       <el-input name="operatorName.SequencingTestOperator" data-vv-as="实验人员" v-validate="'required'" v-model="statusForm.operatorName.SequencingTestOperator" placeholder="请输入实验人员姓名"></el-input>
    </pt-form-item>
    <pt-form-item label="数据分析与报告人员" labelWidth="140px" :required="true">
       <el-input name="operatorName.Checker1" data-vv-as="数据分析与报告人员姓名" v-validate="'required'" v-model="statusForm.operatorName.Checker1" placeholder="请输入数据分析与报告人员姓名"></el-input>
    </pt-form-item>
  </div>
</template>

<script>
import sequencingTechnologyTypeSelector from 'cps/gene-product/selector/import-config-params/componentsWithData/sequencing-technology-type-selector'
import showHandleResultDialog from 'cps/lab-order/show-handle-result-dialog'
import { validate } from 'utils/validate'
import { getSignature } from '@/utils/action'
// 组件class前缀
const prefixCls = 'pt-lab-samples-received-form'

export default {
  name: 'pt-lab-samples-received-form',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    showHandleResultDialog,
    sequencingTechnologyTypeSelector
  },
  props: {
    value: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    isVendor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      statusForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        result: 'REPORT_GENERATE',
        reason: '',
        qualityFile: [],
        operatorName: {
          SequencingTestOperator: '',
          Checker1: ''
        }
      },
      qualityFile: [],
      // oss里存的路径+名字
      saveFileName: '',
      showDialog: false,
      gridData: []
    }
  },
  watch: {
    isLoading (val) {
      if (val) {
        this.qualityFile.splice(0, this.qualityFile.length)
        console.log('this.qualityFile', this.qualityFile)
      }
    },
    statusForm: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    },
    qualityFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.qualityFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
      if (!val) {
        // 更新表格数据
        this.$emit('updateTable', true)
        // 更新待处理订单数量，如若接口会返回该数据的话则不用
        this.$emit('updateAllSize', true)
      }
    },
    formValidate () {
      return validate(this, this.statusForm)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.statusForm.qualityFile = fileList
      // console.log('this.statusForm', this.statusForm)
    },
    qualityFileSub (file) {
      this.uploadForm = new FormData()
      if (file) {
        this.statusForm.qualityFile = []
        this.qualityFile = []
        this.qualityFile.push(file)
        this.statusForm.qualityFile.push(file)
      } else {
        this.qualityFile.push(this.qualityFile[0])
        this.statusForm.qualityFile.push(this.qualityFile[0])
      }
      return false
    },
    async submit (orderIds) {
      // 传入表单和文件
      let data = { action: 'DATA_ANALYSISED', operatorName: this.statusForm.operatorName }
      if (this.isVendor) {
        data.orderIds = orderIds
        data.orderStatusDetail = {
          orderStatusResult: this.statusForm.result,
          reason: this.statusForm.reason
        }
        return this.$store.dispatch('geneOrderStatusUpdateNoFile', data)
      }
      try {
        data.sequencingTechnologyType = this.statusForm.sequencingTechnologyType
        let params = { resourceConfig: 'rawdata', type: 'PRIVATE_RESOURCE', objectId: new Date().getTime(), name: this.qualityFile[0].name }
        var response = await this.$store.dispatch('ossUploadBigFile', params)
        console.log('response', response.data)
        try {
          this.$refs.qualityFile.submit()
          this.uploadForm.append('AccessKeyId', response.data.accesskeyid)
          this.uploadForm.append('policy', response.data.policy)
          this.uploadForm.append('signature', response.data.signature)
          this.saveFileName = response.data.key
          this.uploadForm.append('key', response.data.key)
          // this.uploadForm.append('x-obs-acl', response.data['x-obs-acl'])
          this.uploadForm.append('content-type', response.data['content-type'])
          this.uploadForm.append('file', this.qualityFile[0])
          // this.uploadForm.append('success_action_status', 200) // 指定返回的状态码，默认为204
          let uploadRes = await getSignature(response.data.host, this.uploadForm)
          // let newObj = await this.axios.post(response.data.host, this.uploadForm)
          // let newObj = await this.axios({ method: 'post', url: response.data.host, data: this.uploadForm, withCredentials: true })
          // this.axios.post(response.data.host, this.uploadForm).then(res => {
          // console.log('res----', uploadRes)
          // })
          if (uploadRes.status === 204) {
            console.log('this.saveFileName', this.saveFileName)
            // ---对应字段
            let fileObj = {}
            fileObj.ossUrl = this.saveFileName
            fileObj.type = 'RAW_DATA'
            fileObj.name = this.qualityFile[0].name
            data.orderStatusDetail = {}
            data.orderStatusDetail.attachmentFileInformationList = [fileObj]
            data.orderStatusDetail.orderStatusResult = 'REPORT_GENERATE'
            // 打印传入接口的data
            // console.log('response.data', response.data)
            return this.$store.dispatch('geneOrderStatusUpdate', data)
          } else {
            this.$emit('updateLoading', false)
            this.$message.error('文件上传失败')
          }
        } catch (err) {
          console.log(err)
          this.$emit('updateLoading', false)
          this.$message.error('文件上传失败！')
        }
      } catch (err) {
        console.log(err)
        this.$emit('updateLoading', false)
        this.$message.error('获取签名失败！')
      }
    },
    resetForm () {
      this.statusForm = {
        result: 'REPORT_GENERATE',
        reason: '',
        qualityFile: [],
        operatorName: {
          SequencingTestOperator: '',
          Checker1: ''
        }
      }
      this.qualityFile = []
    },
    submitForm (memberIds = []) {
      // this.submit()
      this.submit(memberIds).then(response => {
        this.$emit('getResult', response)
        this.showDialog = true
        this.gridData = response.data
        this.resetForm()
        // let info = new Set()
        // response.data.forEach(ele => {
        //   if (ele.status !== 'SUCCESS') {
        //     if (ele.message) {
        //       info.add(ele.message)
        //     }
        //     if (ele.status === 'NEED_APPROVAL') {
        //       info.add('进入待处理')
        //     }
        //     if (ele.status === 'FAIL') {
        //       info.add('订单操作失败')
        //     }
        //     if (ele.status === 'NOT_EXECUTED') {
        //       info.add('操作未执行')
        //     }
        //     if (ele.status === 'VALIDATION_FAILED') {
        //       info.add('订单校验失败')
        //     }
        //   }
        // })
        // if (Array.from(info).length) {
        //   this.$emit('updateLoading', false)
        //   this.$message.warning(Array.from(info).toString())
        // } else {
        //   // 更新表格数据
        //   this.$emit('updateTable', true)
        //   // 更新待处理订单数量，如若接口会返回该数据的话则不用
        //   this.$emit('updateAllSize', true)
        //   this.$message.success('操作成功！')
        // }
      }).catch(err => {
        this.$emit('updateLoading', false)
        this.$emit('getResult')
        this.$message.error(err || '操作失败！')
      })
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.process-status-form{
  margin:20px 0;
  el-textarea,.el-textarea__inner,.el-input__inner{
    width:500px;
  }
}
</style>
